import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { getBudgetDriversOptions } from './getBudgetDriversOptions'
import { BudgetDriver } from '../../../types/budgetDriver/BudgetDriver'

export const useCtxBudgetDrivers = <TData = BudgetDriver[]>(select?: (data: BudgetDriver[]) => TData) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = getBudgetDriversOptions(companyId, select)
  return useQuery(options)
}
